// @stayai checkbox custom script
(function() {

  const SELECTORS = {
    atcForm: `[data-block-type='buy-buttons'] product-form form.shopify-product-form[action='/cart/add'][method='post']`,
    currentVariant: `input[name='id']`,
    stayai_subs_checkbox: `input#stayai_subs_checkbox`,
    allVariantOptions: `.product-info [data-block-type='variant-picker'] .variant-option input[type='radio']`,
    selectedVariantOption: (variantId) => `.product-info [data-block-type='variant-picker'] .selected.variant-option[data-variant-id] input[value='${variantId}']`,
    // Single-variant products with subscriptions store data on this element
    singleVariantWithSubs: `.product-info .has-only-default-variant[data-selling-plan-id]`,
    // Match both main product forms AND featured/bundle product forms
    atcBtn: `buy-buttons[form^='product-form-main-'] button[type='submit'], buy-buttons[form^='product-form-featured-product-'] button[type='submit']`,
    // Price display elements in the price-list
    salePrice: `.product-info price-list sale-price`,
    percentageBadge: `.product-info price-list .price-list__percentage-badge`
  };

  // Cache frequently accessed elements
  let cachedCheckbox = null;
  let cachedAtcBtn = null;

  // Helper to get cached checkbox or query it
  function getCheckbox() {
    return cachedCheckbox || (cachedCheckbox = document.querySelector(SELECTORS.stayai_subs_checkbox));
  }

  // Helper to get cached ATC button or query it
  function getAtcBtn() {
    return cachedAtcBtn || (cachedAtcBtn = document.querySelector(SELECTORS.atcBtn));
  }

  // Function to get the currently selected variant option element
  function getSelectedVariantElement(form) {
    if (!form) return null;

    const currentVariant = form.querySelector(SELECTORS.currentVariant)?.value;
    if (!currentVariant) return null;

    return document.querySelector(SELECTORS.selectedVariantOption(currentVariant));
  }

  // Function to update ATC button text based on checkbox state and variant prices
  function updateAtcBtnPrice(form) {
    const atcBtn = getAtcBtn();
    if (!atcBtn) return;

    const checkbox = getCheckbox();
    const isChecked = checkbox?.checked;

    // Check if there are any variant options on this page (multi-variant products)
    const allVariantOptions = document.querySelectorAll(SELECTORS.allVariantOptions);
    
    if (allVariantOptions.length) {
      // Multi-variant product: get prices from selected variant
      const selectedVariantElement = getSelectedVariantElement(form);
      if (!selectedVariantElement) {
        // Variant options exist but none selected - this shouldn't normally happen
        // Don't modify button text, let theme handle it
        return;
      }

      const sellingPlanPrice = selectedVariantElement.getAttribute('data-selling-plan-price');
      const variantPrice = selectedVariantElement.getAttribute('data-price');

      // If no prices available in data attributes, don't modify button
      if (!sellingPlanPrice && !variantPrice) {
        return;
      }

      // Update button text based on checkbox state
      atcBtn.textContent = isChecked
        ? `Add to cart | ${sellingPlanPrice || ''}`
        : `Add to cart | ${variantPrice || ''}`;
      return;
    }

    // Check for single-variant products with subscriptions (like bundles)
    const singleVariantElement = document.querySelector(SELECTORS.singleVariantWithSubs);
    if (singleVariantElement) {
      const sellingPlanPrice = singleVariantElement.getAttribute('data-selling-plan-price');
      const variantPrice = singleVariantElement.getAttribute('data-price');

      // If no prices available in data attributes, don't modify button
      if (!sellingPlanPrice && !variantPrice) {
        return;
      }

      // Update button text based on checkbox state
      atcBtn.textContent = isChecked
        ? `Add to cart | ${sellingPlanPrice || ''}`
        : `Add to cart | ${variantPrice || ''}`;
      return;
    }

    // No variant options AND no single-variant with subscriptions
    // This is a simple single-variant product without subscriptions (like Eye Cream)
    // DON'T modify the button - let the theme's original text with price remain
  }

  // Function to update price and savings elements on all variant options
  function updateVariantPriceElements(form) {
    const allVariantOptions = document.querySelectorAll(SELECTORS.allVariantOptions);
    if (!allVariantOptions.length) return;

    const checkbox = getCheckbox();
    const isChecked = checkbox?.checked;

    // Loop through all variant options and update their price/savings elements
    for (const optionInput of allVariantOptions) {
      const parentElement = optionInput.parentElement;
      if (!parentElement) continue;

      const priceEl = parentElement.querySelector('.variant-option__price');
      const savingEl = parentElement.querySelector('.variant-option__savings');
      const hasComparePrice = optionInput.getAttribute('data-has-compare-price') === 'true';

      if (isChecked) {
        // Subscription is checked - show subscription savings for ALL variants
        const subscriptionSavings = optionInput.getAttribute('data-selling-plan-saving-price');
        if (priceEl) priceEl.textContent = optionInput.getAttribute('data-selling-plan-eachitem-price') || '';
        if (savingEl) {
          savingEl.textContent = `Save ${subscriptionSavings || ''}`;
          // Always show savings when subscription is checked (subscription always has savings)
          savingEl.style.display = '';
        }
      } else {
        // Subscription is unchecked - only show savings if variant has compare_at_price
        const regularSavings = optionInput.getAttribute('data-saving-price');
        if (priceEl) priceEl.textContent = optionInput.getAttribute('data-eachitem-price') || '';
        if (savingEl) {
          if (hasComparePrice && regularSavings) {
            savingEl.textContent = `Save ${regularSavings}`;
            savingEl.style.display = '';
          } else {
            savingEl.textContent = '';
            savingEl.style.display = 'none';
          }
        }
      }
    }
  }

  // Function to update selling_plan input based on current variant
  function updateSellingPlanInput(form) {
    if (!form) return;

    const checkbox = getCheckbox();
    let sellingPlanInput = form.querySelector('input[name="selling_plan"]');

    // If checkbox doesn't exist or not checked, ensure selling_plan is empty
    if (!checkbox || !checkbox.checked) {
      if (sellingPlanInput) {
        sellingPlanInput.value = '';
      }
      return;
    }

    // Get or create selling_plan input
    if (!sellingPlanInput) {
      sellingPlanInput = createSellingPlanInput('', form);
    }

    // Try to get selling_plan_id from multi-variant selector first
    const selectedVariantElement = getSelectedVariantElement(form);
    if (selectedVariantElement) {
      sellingPlanInput.value = selectedVariantElement.getAttribute('data-selling-plan-id') || '';
      return;
    }

    // Try to get selling_plan_id from single-variant element (bundles)
    const singleVariantElement = document.querySelector(SELECTORS.singleVariantWithSubs);
    if (singleVariantElement) {
      sellingPlanInput.value = singleVariantElement.getAttribute('data-selling-plan-id') || '';
      return;
    }

    // No variant data found, clear the selling plan
    sellingPlanInput.value = '';
  }

  // Function to update the main price display (sale-price and percentage badge)
  // Note: Percentage badge only updates on bundle products (single-variant with subscriptions)
  function updatePriceDisplay(form) {
    // Check if this is a single-variant product with subscriptions (bundle)
    const singleVariantElement = document.querySelector(SELECTORS.singleVariantWithSubs);
    
    // Only proceed if this is a bundle product
    if (!singleVariantElement) return;

    const salePrice = document.querySelector(SELECTORS.salePrice);
    const percentageBadge = document.querySelector(SELECTORS.percentageBadge);
    
    // If no price display elements found, nothing to update
    if (!salePrice && !percentageBadge) return;

    const checkbox = getCheckbox();
    const isChecked = checkbox?.checked;

    // Get the prices and percentages based on checkbox state
    if (isChecked) {
      const subscriptionPrice = singleVariantElement.getAttribute('data-selling-plan-price');
      const subscriptionPercent = singleVariantElement.getAttribute('data-selling-plan-percent-savings');
      
      if (salePrice && subscriptionPrice) {
        // Find the text node or update the content (preserve the sr-only span)
        const srOnlySpan = salePrice.querySelector('.sr-only');
        if (srOnlySpan) {
          salePrice.innerHTML = '';
          salePrice.appendChild(srOnlySpan);
          salePrice.appendChild(document.createTextNode(subscriptionPrice));
        } else {
          salePrice.textContent = subscriptionPrice;
        }
      }
      
      if (percentageBadge && subscriptionPercent) {
        // Update percentage badge - preserve the sr-only span
        const srOnlySpan = percentageBadge.querySelector('.sr-only');
        if (srOnlySpan) {
          percentageBadge.innerHTML = '';
          percentageBadge.appendChild(srOnlySpan);
          percentageBadge.appendChild(document.createTextNode(`Save ${subscriptionPercent}%`));
        } else {
          percentageBadge.textContent = `Save ${subscriptionPercent}%`;
        }
        percentageBadge.style.display = '';
      }
    } else {
      const regularPrice = singleVariantElement.getAttribute('data-price');
      const regularPercent = singleVariantElement.getAttribute('data-percent-savings');
      const hasComparePrice = singleVariantElement.getAttribute('data-has-compare-price') === 'true';
      
      if (salePrice && regularPrice) {
        // Find the text node or update the content (preserve the sr-only span)
        const srOnlySpan = salePrice.querySelector('.sr-only');
        if (srOnlySpan) {
          salePrice.innerHTML = '';
          salePrice.appendChild(srOnlySpan);
          salePrice.appendChild(document.createTextNode(regularPrice));
        } else {
          salePrice.textContent = regularPrice;
        }
      }
      
      if (percentageBadge) {
        if (hasComparePrice && regularPercent && parseInt(regularPercent) > 0) {
          // Update percentage badge - preserve the sr-only span
          const srOnlySpan = percentageBadge.querySelector('.sr-only');
          if (srOnlySpan) {
            percentageBadge.innerHTML = '';
            percentageBadge.appendChild(srOnlySpan);
            percentageBadge.appendChild(document.createTextNode(`Save ${regularPercent}%`));
          } else {
            percentageBadge.textContent = `Save ${regularPercent}%`;
          }
          percentageBadge.style.display = '';
        } else {
          // Hide badge when no compare_at_price or 0% savings
          percentageBadge.style.display = 'none';
        }
      }
    }
  }

  // Batch update function to update all related elements
  function updateAll(form) {
    updateSellingPlanInput(form);
    updateAtcBtnPrice(form);
    updateVariantPriceElements(form);
    updatePriceDisplay(form);
  }

  // Wait for the form to be ready, then optionally wait for checkbox
  elementReady(SELECTORS.atcForm).then((form) => {
    if (!form) return;

    // Function to complete initialization
    function initializeWithCheckbox(checkbox) {
      // Cache the checkbox if found
      if (checkbox) {
        cachedCheckbox = checkbox;
      }

      // Ensure selling_plan input exists (only if checkbox exists)
      if (checkbox && !form.querySelector('input[name="selling_plan"]')) {
        createSellingPlanInput(null, form);
      }

      // Update all on initial load (after a delay to ensure theme JS has finished)
      setTimeout(() => updateAll(form), 100);
      
      // Also update on window load as a fallback for late theme scripts
      window.addEventListener('load', () => {
        setTimeout(() => updateAll(form), 100);
      });

      // Listen for variant changes (event bubbles from form)
      document.addEventListener('variant:change', () => updateAll(form));

      // Listen for checkbox changes (only if checkbox exists)
      if (checkbox) {
        checkbox.addEventListener('change', () => {
          updateAll(form);

          // Dispatch variant:change event to notify other listeners
          const currentVariantId = form.querySelector(SELECTORS.currentVariant)?.value;
          if (currentVariantId) {
            form.dispatchEvent(new CustomEvent('variant:change', {
              bubbles: true,
              detail: {
                formId: form.id,
                variant: { id: currentVariantId },
              },
            }));
          }
        });
      }

      // Listen for form submit and update selling_plan right before submission
      // This runs in capture phase BEFORE theme.js creates FormData (line 4028-4029)
      // so the selling_plan value is guaranteed to be in the form when FormData is created
      document.addEventListener('submit', (event) => {
        const targetForm = event.target.tagName === 'FORM' ? event.target : event.target.closest('form');
        if (targetForm === form) {
          updateSellingPlanInput(form);
        }
      }, true); // Use capture phase to run before other handlers
    }

    // Check if checkbox already exists in DOM
    const existingCheckbox = document.querySelector(SELECTORS.stayai_subs_checkbox);
    if (existingCheckbox) {
      // Checkbox exists, initialize immediately
      initializeWithCheckbox(existingCheckbox);
    } else {
      // Checkbox doesn't exist yet - wait briefly, then initialize anyway
      // Use a short timeout to give checkbox a chance to load, but don't wait forever
      const checkboxTimeout = setTimeout(() => {
        // Initialize without checkbox (for products without subscriptions)
        initializeWithCheckbox(null);
      }, 100);

      // Also set up a watcher in case checkbox loads after timeout
      elementReady(SELECTORS.stayai_subs_checkbox).then((checkbox) => {
        clearTimeout(checkboxTimeout);
        initializeWithCheckbox(checkbox);
      }).catch(() => {
        // Checkbox never found, that's okay - products without subscriptions
      });
    }
  }).catch(e => console.error('Error initializing stayai-pdp:', e))


  // Helper function to wait for element to be ready
  function elementReady(selector) {
    return new Promise((resolve) => {
      const el = document.querySelector(selector);
      if (el) {
        resolve(el);
        return;
      }

      const observer = new MutationObserver(() => {
        const foundElements = document.querySelectorAll(selector);
        if (foundElements.length > 0) {
          observer.disconnect();
          resolve(foundElements[0]);
        }
      });

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    });
  }

  // Subscription info tooltip behavior (hover on desktop, tap on mobile)
  elementReady('[data-subs-info-trigger]').then((trigger) => {
    const tooltip = document.querySelector('[data-subs-info-tooltip]');
    const closeBtn = document.querySelector('[data-subs-info-close]');
    if (!trigger || !tooltip) return;

    let hideTimeout = null;
    const isTouchDevice = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    function show() {
      clearTimeout(hideTimeout);
      tooltip.classList.add('is-visible');
    }

    function hide() {
      tooltip.classList.remove('is-visible');
    }

    function hideWithDelay() {
      hideTimeout = setTimeout(hide, 200);
    }

    trigger.addEventListener('mouseenter', () => {
      if (!isTouchDevice()) show();
    });
    trigger.addEventListener('mouseleave', () => {
      if (!isTouchDevice()) hideWithDelay();
    });
    tooltip.addEventListener('mouseenter', () => {
      if (!isTouchDevice()) { clearTimeout(hideTimeout); }
    });
    tooltip.addEventListener('mouseleave', () => {
      if (!isTouchDevice()) hideWithDelay();
    });

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      tooltip.classList.toggle('is-visible');
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        hide();
      });
    }

    document.addEventListener('click', (e) => {
      if (!trigger.contains(e.target) && !tooltip.contains(e.target)) {
        hide();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') hide();
    });
  });

  // Helper function to create selling_plan input
  function createSellingPlanInput(sellingPlanId, form) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'selling_plan';
    input.classList.add('stayai-selling-plan--js-added');
    if (sellingPlanId) {
      input.value = sellingPlanId;
    }
    form.appendChild(input);
    return input;
  }


})();